// extracted by mini-css-extract-plugin
module.exports = {"Emojify":"bbc_a bhc_g"};